'use strict';

const SV = require('server-vars');
const tracking = require('dibs-tracking');

const FOLLOW_SEARCH_TRACKING_POSITION = 'save search - search/browse page - callout';
const FOLLOW_SEARCH_SAVE_LABEL = 'top of results - callout';

const FOLLOW_DEALER_TRACKING_POSITION = 'favorite dealer - dealer storefront - callout';
const FOLLOW_DEALER_SAVE_LABEL = 'sellers page - callout';

const SAVE_ITEM_TRACKING_POSITION = 'save item - search/browse page - callout';
const SAVE_ITEM_LABEL = 'search/browse - callout';

const SEARCH_BOX_LABEL = 'global search - callout';

let isActive = false;
let isActiveSearchBox = false;

const calloutTracking = {

    getTracking() {
        return {
            followSearch: {
                login: {
                    trackingPosition: isActive ? FOLLOW_SEARCH_TRACKING_POSITION : false
                },
                save: {
                    label: isActive ? FOLLOW_SEARCH_SAVE_LABEL : false
                }
            },
            followDealer: {
                login: {
                    trackingPosition: isActive ? FOLLOW_DEALER_TRACKING_POSITION : false
                },
                save: {
                    label: isActive ? FOLLOW_DEALER_SAVE_LABEL : false
                }
            },
            saveItem: {
                login: {
                    trackingPosition: isActive ? SAVE_ITEM_TRACKING_POSITION : false
                },
                save: {
                    label: isActive ? SAVE_ITEM_LABEL : false
                }
            },
            searchBox: {
                open: {
                    label: isActiveSearchBox ? SEARCH_BOX_LABEL : false
                }
            }
        };
    },

    activateTracking(active) {
        isActive = !!active;
    },

    activateSearchBoxTracking(active) {
        isActiveSearchBox = !!active;
    },

    isActive() {
        return isActive;
    },

    followSearch() {
        const category = 'search favoriting';
        const action = 'search favoriting callout displayed';
        const label = SV.get('tracking.initialDataLayerInfo.pageSubType');

        tracking.trackEvent({ category, action, label });
    },

    followDealer() {
        const category = 'dealer favoriting';
        const action = 'dealer favoriting callout displayed';
        const label = SV.get('tracking.initialDataLayerInfo.pageSubType');

        tracking.trackEvent({ category, action, label });
    },

    saveItem() {
        const category = 'item favoriting';
        const action = 'item favoriting callout displayed';
        const label = SV.get('tracking.initialDataLayerInfo.pageSubType');

        tracking.trackEvent({ category, action, label });
    },

    searchBox() {
        const category = 'search favoriting';
        const action = 'search feature callout displayed';
        const label = SV.get('tracking.initialDataLayerInfo.pageSubType');

        tracking.trackEvent({ category, action, label });
    }

};

module.exports = calloutTracking;



// WEBPACK FOOTER //
// ./assets/js/components/Callout/calloutTracking.es.js